import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import type { TFunction } from 'react-i18next'
import { Input } from '../../../components'
import type { Credit } from '../../../types'
import type { ExtendedCredit } from './Credits'

interface TableDisplayParams {
    onSelectCredit: (id: number, isSelected: boolean) => void;
    t: TFunction;
}

const tableDisplay = ({ onSelectCredit, t }: TableDisplayParams) => {
    const elements = [
        {
            onlyOnMobile: true,
            field: 'type',
            label: t('credit-type'),
            props: { style: { textAlign: 'left' } },
            transform: null,
            width: '200px',
        },
        {
            onlyOnMobile: true,
            field: null,
            label: '',
            props: { align: 'center' },
            transform: ({ id, selected = false }: ExtendedCredit) => (
                <Input
                    onChange={(e: React.MouseEvent) => {
                        e.stopPropagation()
                        onSelectCredit(id, !selected)
                    }}
                    type="check"
                    value={selected}
                />
            ),
            width: '50px',
        },
        {
            onlyOnMobile: true,
            field: 'start_date',
            label: t('credit-start-date'),
            props: { paddingLeft: '15px', textAlign: 'left' },
            transform: (dateStart: string) => (
                <>{moment(dateStart).format('DD/MM/YYYY')}</>
            ),
            width: '100px',
        },
        {
            field: null,
            label: '',
            props: null,
            transform: () => (
                <FontAwesomeIcon icon="chevron-right" />
            ),
            width: '20px',
        },
        {
            field: 'type',
            label: t('credit-type'),
            props: null,
            transform: null,
            width: '200px',
        },
        {
            field: null,
            label: '',
            props: { align: 'center' },
            transform: ({ id, selected = false }: ExtendedCredit) => (
                <Input
                    onChange={(e: React.MouseEvent) => {
                        e.stopPropagation()
                        onSelectCredit(id, !selected)
                    }}
                    type="check"
                    value={selected}
                />
            ),
            width: '50px',
        },
        {
            field: 'start_date',
            label: t('credit-start-date'),
            props: { paddingLeft: '15px' },
            transform: (dateStart: string) => (
                <>{moment(dateStart).format('DD/MM/YYYY')}</>
            ),
            width: '120px',
        },
        {
            field: 'end_date',
            label: t('credit-end-date'),
            props: null,
            transform: (dateEnd: string) => (
                <>{moment(dateEnd).format('DD/MM/YYYY')}</>
            ),
            width: '120px',
        },
        {
            field: 'skus',
            label: t('credit-skus'),
            props: { align: 'center' },
            transform: (skus: Credit['skus']) => (
                <>{skus.length}</>
            ),
            width: '80px',
        },
    ]

    return elements
}

export default tableDisplay
